import React from 'react';
import './Footer.css'; // 스타일링을 위한 CSS 파일을 임포트합니다.

const Footer = () => {
  return (
    <footer>
      <div id="copyright">
        Copyright ⓒ 2000 KLATA All rights reserved. ⓒ 2018 made by <a href="http://www.elcsoft.com" target="_blank" rel="noreferrer">ELCSOFT</a>
      </div>
    </footer>
  );
};

export default Footer;

